import { getDaysDifferenceAbs } from "../../../lib/dateScripts";
import BodySimpleModalV3 from "./BodySimpleModalV3";

export default function PayerTypeStatusGlobalModal({children, date, user, mode, isDisabled}) {
    return <BodySimpleModalV3 message={date ? <div>
            <div>Days In Payer {mode ? 'Type' : 'Status'}: {getDaysDifferenceAbs(date)}</div>
            <div>Modified by: {user?.name}</div>
        </div> : null} disabled={isDisabled}>
        {children}
    </BodySimpleModalV3>
}